<template>

    <form class="md:w-3/6 m-auto" id="contact" @submit.prevent="submit">

        <h1 class="text-cavilam-primary text-4xl font-bold my-4 text-center">{{ __('Contact') }}</h1>

        <div v-if="$page.props.flash.succes" class="text-center py-4 text-green-500 text-sm font-semibold">{{ __($page.props.flash.succes) }}</div>
        <div v-if="$page.props.flash.erreur" class="text-center py-4 text-green-500 text-sm font-semibold">{{ __($page.props.flash.erreur) }}</div>

        <div class="flex flex-wrap -mx-3 mb-6">
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="prenom">
                    {{ __('Prenom') }} <sup class="text-red-600">*</sup>
                </label>
                <input id="prenom" type="text" v-model="form.prenom" :class="{'border border-red-500': this.errors.length}" class="appearance-none mb-3 block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                <p v-if="errors.includes('prenom')" class="text-red-500 text-xs italic">{{ __('veuillez_remplir_ce_champ') }}</p>
            </div>
            <div class="w-full md:w-1/2 px-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="nom">
                    {{ __('Nom') }} <sup class="text-red-600">*</sup>
                </label>
                <input v-model="form.nom" :class="{'border border-red-500': this.errors.length}" class="appearance-none mb-3 block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="nom" type="text">
                <p v-if="errors.includes('nom')" class="text-red-500 text-xs italic">{{ __('veuillez_remplir_ce_champ') }}</p>
            </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-6">
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="tel">
                    {{ __('Telephone') }}
                </label>
                <input v-model="form.tel" class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="tel" type="tel">
            </div>
            <div class="w-full md:w-1/2 px-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="email">
                    {{ __('Adresse_email') }} <sup class="text-red-600">*</sup>
                </label>
                <input v-model="form.email" :class="{'border border-red-500': this.errors.length}" class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="email" type="email">
                <p v-if="errors.includes('email')" class="text-red-500 text-xs italic">{{ __('veuillez_remplir_ce_champ') }}</p>
            </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-6">
            <div class="w-full px-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="objet">
                    {{ __('Objet') }} <sup class="text-red-600">*</sup>
                </label>
                <input v-model="form.titre" :class="{'border border-red-500': this.errors.length}" class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="objet" type="text">
                <p v-if="errors.includes('titre')" class="text-red-500 text-xs italic">{{ __('veuillez_remplir_ce_champ') }}</p>
            </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-6">
            <div class="w-full px-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="message">
                    {{ __('Message') }} <sup class="text-red-600">*</sup>
                </label>
                <textarea id="message" v-model="form.msg" :class="{'border border-red-500': this.errors.length}" class="no-resize appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-48 resize-none"></textarea>
                <p v-if="errors.includes('msg')" class="text-red-500 text-xs italic">{{ __('veuillez_remplir_ce_champ') }}</p>
            </div>
        </div>
        <div class="text-center">
            <button class="inline-block px-6 py-2 text-xs
                font-medium leading-6 text-center text-white
                uppercase transition bg-cavilam-primary rounded
                shadow ripple hover:shadow-lg hover:bg-blue-800
                focus:outline-none" type="submit">{{ __('Envoyer') }}</button>
        </div>
    </form>
</template>

<script>
import App from '@/Layouts/App'
import Button from "../Components/Button";


export default {


    data: function (){

        return {
            form: this.$inertia.form({
                nom: '',
                prenom: '',
                tel: '',
                email: '',
                titre: '',
                msg: '',
            }),
            errors: []
        }
    },

    methods: {

        submit() {
            for (const [key, value] of Object.entries(this.form)) {
                if(value === '' && key !== 'tel')
                    this.errors.push(key);
                else
                    if (this.errors.indexOf(key) !== -1)
                        this.errors.splice(this.errors.indexOf(key), 1);
            }

            if(!this.errors.length)
                this.$inertia.post('/contact', this.form);
            else
                return false;
        },

    },
    name: "Contact",
    components: {Button},
    layout: App,
}
</script>

